import React from "react";
import PropTypes from "prop-types";

import { MenuItem, FeaturedItem } from "@menu/components";
import styles from './section-content.module.scss';

const SectionContent = (props) => {

  // Split into columns via column breaks
  let columns = props.content.reduce((acc, item) => {
    if (!acc.length) acc = [[]]
    if (item.kind === 'column break') {
      acc.push([])
    } else {
      acc[acc.length - 1].push(item);
    }
    return acc;
  }, {});

  const currentPageUrl = $('.js-menu').data('currentPage');

  const linkables = props.content.filter((item) => {
    return (item.kind === "link" || item.kind === "heading")
  }, []);

  const links = linkables.reduce((acc, item) => {
    if (item.kind === "link") {
      acc.push(item);
    } else if (item.kind === "heading") {
      acc.push(item.link);
    }

    return acc;
  }, []);

  const renderMenuItem = (item) => {
    let url = (item.kind === "heading") ? item.link.url : item.url;
    let isCurrentPage = url === currentPageUrl;
    let isFirstLink = links.find(link => link.url === url).id === item.id    
    let isActive = isCurrentPage && isFirstLink;

    return <MenuItem key={`${item.id}-${item.type}`} item={item} active={isActive} />
  };

  return (
    <div className="nav-group nav-group-1">
      {columns.length > 0 && columns.map((column, index) => (
        <div
          key={`${props.sectionId}-${index}`}
          className="nav-group-list nav-col-1"
        >
          <ul>
            {column.map((item) => {
              return renderMenuItem(item)
            })}
          </ul>
        </div>
      ))}
      {Object.prototype.hasOwnProperty.call(props.featuredItem, 'link') &&
        <div className={`${styles.navArticle} flex-l flex-jc-sb-l flex-w-w-l nav-col-1`}>
          <FeaturedItem item={props.featuredItem} />
        </div>
      }
    </div>
  );
}

SectionContent.propTypes = {
  sectionId: PropTypes.number.isRequired,
  content: PropTypes.any.isRequired,
  featuredItem: PropTypes.any
}

export default SectionContent;
